














import { Vue, Watch, Component } from 'vue-property-decorator'
import Banner from '@/components/Banner.vue'
import TabList from '@/components/TabList.vue'

@Component({
  components: {
    Banner,
    TabList
  }
})
export default class AboutUs extends Vue {
  tabList = [
    { id: 0, name: 'talkmateIntro', text: '全球说简介', path: 'talkmate-intro' },
    // { id: 1, name: 'utnIntro', text: 'UTN简介', path: 'utn-intro' },
    // { id: 2, name: 'professonalCommittee', text: '专家顾问', path: 'professonal-committee' },
    { id: 3, name: 'joinUs', text: '加入我们', path: 'join-us' }
  ]
  navigation = [
    {
      text: '首页',
      path: '/'
    },
    {
      text: '关于我们',
      path: '/about-us'
    },
    {
      text: '全球说介绍',
      path: ''
    }
  ]
  created () {
    this.changeRoute()
  }
  @Watch('$route')
  onRouteChanged () {
    this.changeRoute()
  }
  changeRoute () {
    this.navigation.forEach((item:any, index:number) => {
      console.log('item', item)
      if (item.path === '') {
        item.text = this.$route.query.type ? this.$route.query.type : '全球说介绍'
      }
    })
  }
}
